<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3>{{CPAResultLan.indexText}}</h3>
      </div>
      <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
        <mtable
          v-if="trData"
          :thData="thData"
          :trData="trData"
          :page="page"
          :selPage="selPage"
          :link="link"
          :back="back"
          :multiLanguage="CPAResultLan"
          :jsonExcelAjax="jsonExcelAjax"
          :downLoadTran="downLoadTran"
          :name="name"
          @tableChange="tableAjax"
        >
          <div slot="handle" class="CPAHandle">
            <div class="searchDiv">
              <span>{{CPAResultLan.start_time}}</span>
              <el-date-picker
                v-model="beginTime"
                :placeholder="CPAResultLan.selectTimeText"
                style="width: 200px"
              ></el-date-picker>
            </div>
            <div class="searchDiv">
              <span>{{CPAResultLan.end_time}}</span>
              <el-date-picker
                v-model="endTime"
                :placeholder="CPAResultLan.selectTimeText"
                style="width: 200px"
              ></el-date-picker>
            </div>
            <div class="btnDiv">
              <el-button type="primary" @click="searchData">{{CPAResultLan.search}}</el-button>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from "../../comm/mytable";
import { getTimeDiff, formatDate, updateTimeByUtc } from "common/js/util";
import { URL_IBMONTHLYINDEX } from "api/commissionApi";
import { Api } from "api/commissionEnv";
let api = new Api();

export default {
  name: "CPACommissionResult",
  mixins: [
    require("common/mixin/base.js").base({ CPAResultLan: "cpaIBResult" })
  ],
  props: ["curArea"],
  data() {
    return {
      trData: [],
      beginTime: "",
      endTime: "",
      timeDiff: 0,
      url: "",
      area: [],
      loading: true,
      changeTime: false,
      link: {
        key: ["CPACommissionResult"],
        path: "CPAMonthlyCommResult"
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  computed: {
    back() {
      return JSON.stringify({
        path: "CPACommissionResult",
        beginTime: formatDate(this.beginTime),
        endTime: formatDate(this.endTime),
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit
      });
    },
    thData() {
      return this.CPAResultLan.cpaIndexTh;
    },
    name() {
      return this.CPAResultLan.indexText;
    },
    downLoadTran() {
      return { STATUS: this.CPAResultLan.statusList };
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        ajaxPar: {
          type: "IB",
          iscpa: true,
          pageSize: this.page.pageLeng,
          pageNum: 0,
          lang: this.LANGUAGE,
          beginTime: formatDate(this.beginTime),
          endTime: formatDate(this.endTime)
        }
      };
    }
  },
  mounted() {
    this.area = JSON.parse(sessionStorage.getItem("area")).GM;
    this.timeDiff = getTimeDiff();
    if (sessionStorage.getItem("back")) {
      let backObj = JSON.parse(sessionStorage.getItem("back"));
      if (backObj.path === "CPACommissionResult") {
        this.beginTime = backObj.beginTime;
        this.endTime = backObj.endTime;
        this.page.active = backObj.pageNum + 1;
        this.selPage.limit = backObj.pageSize;
      }
      this.tableAjax();
      sessionStorage.removeItem("back");
    } else {
      this.tableAjax();
    }
  },
  methods: {
    searchData() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax() {
      this.loading = true;
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea,URL_IBMONTHLYINDEX)
      let obj = {
        params: {
          type: "IB",
          iscpa: true,
          beginTime: this.beginTime,
          endTime: this.endTime,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      };
      this.$http.get(this.url, obj).then(res => {
        this.trData = res.data.data.rows;
        this.page.pageLeng = res.data.data.count;
        this.setOfficeState();
        this.loading = false;
      });
    },
    setOfficeState() {
      let list = this.CPAResultLan.statusList;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index];
          temp.CPACommissionResult = this.CPAResultLan.cpaIndexTh[1].name;
          temp.status =
            temp.STATUS || temp.STATUS == 0 ? list[temp.STATUS] : "";
          if (this.changeTime)
            temp.LAST_UPDATE = updateTimeByUtc(this.timeDiff, temp.LAST_UPDATE);
        });
      }
    }
  },
  watch: {
    CPAResultLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea() {
      (this.beginTime = ""), (this.endTime = ""), (this.page.active = 1);
      if (this.area.indexOf(this.curArea) > -1) this.$router.push("ibSetting");
      else this.tableAjax();
    }
  },
  components: {
    mtable
  }
};
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
}
.CPAHandle {
  float: left;
  .searchDiv {
    float: left;
    margin-right: 20px;
  }
  .btnDiv {
    float: left;
    margin-right: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// CPACommissionResult.vue?9275fa70